import {Button, Input, Space, Tooltip} from "antd";
import {CustomModal} from "../../../../components/modal";
import {useGetProfileContext} from "../../../../context/profile/profile-context";
import {StyledModalContentWrapper} from "../../../../components/calls/upcoming-calls/call-card/call-card.style";
import {StyledSuccessServiceContent} from "../../../../components/calls/service/service-form/service-form.style";
import {
  CopyOutlined,
  FacebookFilled,
  MailFilled,
  TwitterOutlined,
} from "@ant-design/icons";
import {
  handleFacebookLink,
  handleMailLink,
  handleTwitterLink,
} from "../../../../utils/products";
import {handleServiceBookingLink} from "../../../../utils/meeting";
import {useState} from "react";
import {REBRAND_BASE_URL} from "../../../../services/config";

export function CreateServiceSuccessModal({
  handleOk,
  openSuccessfulModal,
  serviceId,
  slug,
  serviceName,
  modalDescription,
  modalTitle,
  tinyUrl,
}: {
  openSuccessfulModal: boolean;
  handleOk: () => void;
  modalTitle: string;
  modalDescription: string;
  tinyUrl?: string;
  slug?: string;
  serviceId?: string | number;
  serviceName?: string;
}) {
  const {state: profileState} = useGetProfileContext();
  const [toolTipText, setToolTipText] = useState<string>("copy service url");
  return (
    <CustomModal
      visibleState={openSuccessfulModal}
      title={modalTitle}
      okFunc={handleOk}
      cancelFunc={handleOk}
      footerContent={[
        <Button
          key="publicProfile"
          type="primary"
          size="small"
          // onClick={() => navigate(`/${getProfileQuery.data?.username}`)}
          href={`${REBRAND_BASE_URL}/${profileState.profileData.username}`}
          target="_blank"
        >
          View my public profile
        </Button>,
        <Button key="gotIt" size="small" type="default" onClick={handleOk}>
          Got it!
        </Button>,
      ]}
    >
      <StyledModalContentWrapper>
        <StyledSuccessServiceContent>
          <p className="success-text">{modalDescription}</p>
          <div className="success-share-info">
            <Input.Group compact style={{display: "flex"}}>
              <Input
                size="large"
                readOnly
                defaultValue={handleServiceBookingLink({
                  tinyUrl,
                  serviceId: serviceId ?? "",
                  slug: slug ?? "",
                  username: profileState.profileData.username,
                  windowNav: true,
                })}
              />
              <Tooltip title={toolTipText}>
                <Button
                  size="small"
                  icon={<CopyOutlined />}
                  onClick={() =>
                    navigator.clipboard
                      .writeText(
                        handleServiceBookingLink({
                          tinyUrl,
                          serviceId: serviceId ?? "",
                          slug: slug ?? "",
                          username: profileState.profileData.username,
                          windowNav: true,
                        })
                      )
                      .then(() => setToolTipText("copied"))
                  }
                />
              </Tooltip>
            </Input.Group>
            <p>or</p>
            <Space direction="horizontal" size={16}>
              <div>
                <Button
                  shape="circle"
                  size="small"
                  icon={<FacebookFilled />}
                  style={{backgroundColor: "#EBEEF5", color: "#3B5998", border: "none"}}
                  type="link"
                  target="_blank"
                  href={handleFacebookLink({
                    username: profileState.profileData.username,
                  })}
                  title="Share on facebook"
                />
              </div>
              <div>
                <Button
                  title="Share on twitter"
                  shape="circle"
                  size="small"
                  icon={<TwitterOutlined />}
                  target="_blank"
                  style={{backgroundColor: "#E6F7FD", color: "#00ACEE", border: "none"}}
                  href={handleTwitterLink({
                    textContent: `I just created a session called "${serviceName}" on Coachli. Book a service with me today on Coachli!&url=${REBRAND_BASE_URL}/${profileState.profileData.username}/sessions/${slug}?id=${serviceId}}`,
                    username: profileState.profileData.username,
                  })}
                />
              </div>
              <div>
                <Button
                  title="Send mail"
                  shape="circle"
                  size="small"
                  icon={<MailFilled />}
                  style={{backgroundColor: "#FBECEB", color: "#DB4437", border: "none"}}
                  href={handleMailLink({
                    subject: "I wanted you to see this site",
                    body: `Book a service with me on Coachli ${handleServiceBookingLink({
                      tinyUrl,
                      serviceId: serviceId ?? "",
                      slug: slug ?? "",
                      username: profileState.profileData.username,
                      windowNav: true,
                    })}`,
                  })}
                />
              </div>
            </Space>
          </div>
        </StyledSuccessServiceContent>
      </StyledModalContentWrapper>
    </CustomModal>
  );
}
